var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevokeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160353",
    "data-name": "Group 160353",
    transform: "translate(-1286 -654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resume_18px",
    transform: "translate(1286.06 654.288)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 18,
    height: 18,
    transform: "translate(-0.059 -0.288)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pause-circle",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(-0.059 -0.288)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    "data-name": "Line 102",
    x1: 12,
    y1: 9,
    transform: "translate(1.941 3.212)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevokeIcon);
export default __webpack_public_path__ + "static/media/revoke-icon.9c9724e2850bf2937e9bc717269bc886.svg";
export { ForwardRef as ReactComponent };